import React, { Component } from "react";
import CommonHeader from "../common/CommonHeader";
import FormWizards from "./FormWizards";
import Moment from "moment";
import PhoneInput from "react-phone-input-2";
import PhoneNumberFormat from "../common/PhoneNumberFormat";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import { Modal, Spinner } from "react-bootstrap";
import Timer from "../common/Timer";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import AuthenticationService from "../../services/AuthenticationService";
import ReservationService from "../../services/ReservationService";
import SpinnerLoader from "../common/SpinnerLoader";
import CardForm from "./CardForm";
import CheckoutFormParking from "./CheckoutFormParking";
import PetCleaningFeeForm from "./PetCleaningFeeForm";
import InjectedTripAddonsPaymentForm from "./TripAddonsPaymentForm";
import Switch from "@mui/material/Switch";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import openeye from "./../../../assets/images/openeye.png";
import closeeye from "./../../../assets/images/closeeye.png";
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import CmsDataService from "../../services/CmsDataService";

class WizardForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentData: localStorage.getItem("trip_details")
        ? JSON.parse(localStorage.getItem("trip_details"))
        : [],
      input: {},
      pagestate: 1,
      id_type: 1,
      loader: false,
      clickAgain: false,
      passwordType: "password",
      clientToken: "",
      password: localStorage.getItem("trip_details")
        ? JSON.parse(localStorage.getItem("trip_details")).password
        : "",
      passwordflag: localStorage.getItem("trip_details")
        ? JSON.parse(localStorage.getItem("trip_details")).passwordflag
        : "",
      submitloader: false,
      editablePhone: false,
      verifyOtpModal: false,
      forntphoto_loader: false,
      backphtoto_loader: false,
      selfiephoto_loader: false,
      classbox: "",
      // Step 2 (dynamic house rules), keyed by property_house_rules.slug -- replaces
      // the old flat is_notification_1..14 fields (Task 9.2). Same three-state
      // semantics as before: key absent = untouched, true = agreed, false = unchecked.
      houseRuleAgreements: {},
      is_notification_15: false,
      card_agree_type: 2,
      guestFrontimageUrl: "",
      guestbackimageUrl: "",
      guestselfieimageUrl: "",
      guestFront: "",
      back_image: "",
      selfie_image: "",
      is_notification_16: "",
      set_channel: localStorage.getItem("trip_details")
        ? JSON.parse(localStorage.getItem("trip_details")).set_channel
        : "",
      signature: "",
      last_name: localStorage.getItem("trip_details")
        ? JSON.parse(localStorage.getItem("trip_details")).guest_user.last_name
        : "",
      first_name: localStorage.getItem("trip_details")
        ? JSON.parse(localStorage.getItem("trip_details")).guest_user.first_name
        : "",
      email: localStorage.getItem("trip_details")
        ? JSON.parse(localStorage.getItem("trip_details")).email
        : "",
      phone_number: localStorage.getItem("trip_details")
        ? JSON.parse(localStorage.getItem("trip_details")).phone_number
        : "",
      old_email: localStorage.getItem("trip_details")
        ? JSON.parse(localStorage.getItem("trip_details")).guest_user.email
        : "",
      guest_slug: localStorage.getItem("trip_details")
        ? JSON.parse(localStorage.getItem("trip_details")).guest_user.slug
        : "",
      confirmation_code: localStorage.getItem("trip_details")
        ? JSON.parse(localStorage.getItem("trip_details")).confirmation_code
        : "",
      lock_type: localStorage.getItem("trip_details")
        ? JSON.parse(localStorage.getItem("trip_details")).property.lock_type
        : "",
      user_token: Math.floor(Math.random(12) * 1000000000000 + 1),
      is_latch_enable: localStorage.getItem("trip_details")
        ? JSON.parse(localStorage.getItem("trip_details")).is_latch_enable
        : "",
      file: "https://d1xsfycladxeij.cloudfront.net/user/profile/thumb/oh_636490df77cd2636490df77cd3.jpg",
      file_input: null,
      is_uploaded: false,
      country_code: "+1",
      otp_type: 1,
      input: {},
      email_error: "",
      signature_error: "",
      deposite_amount: "$500",
      is_email_verified: localStorage.getItem("is_email_verified")
        ? localStorage.getItem("is_email_verified")
        : "",
      is_form_submited: this.props.isformsubmited
        ? this.props.isformsubmited
        : localStorage.getItem("is_form_submited")
        ? localStorage.getItem("is_form_submited")
        : "",
      card_tokenise: localStorage.getItem("card_tokenise")
        ? localStorage.getItem("card_tokenise")
        : "",
      otp_verified_submit: false,
      error: {
        email: "",
        phone_number: "",
        password: "",
        is_notification_15: "",
        is_notification_16: "",
      },
      exist_img: "",
      isLoaded: false,
      editablePhone: false,
      isCardEnable: this.props.isCardEnable,
      Datecheck: this.props.Datecheck,
      parking_payment: localStorage.getItem("parking_payment") || "",
      pet_cleaning_payment: localStorage.getItem("pet_cleaning_payment") || "",
      no_of_vehicle: 1,
      maxVehicle: 1,
      no_of_pet: 1,
      maxPet: 5,
      petCleaningEnabled: false,
      parkingEnabled: false,
      addOnsSubstate: "summary",
      addOnsClientSecret: null,
      addOnsStripeId: null,
      addOnsItems: [],
      addOnsCalculatedAmounts: [],
      vehicleDetails: [{ vehicle_make: "", vehicle_model: "", vehicle_color: "", license_plate_number: "" }],
      addOnsLoader: false,
      addOnsError: "",
    };
    this.changeHandler = this.changeHandler.bind(this);
    this.setNext = this.setNext.bind(this);
    this.setPrevious = this.setPrevious.bind(this);
    this.ClickFileUploadFront = this.ClickFileUploadFront.bind(this);
    this.ClickFileUploadBack = this.ClickFileUploadBack.bind(this);
    this.ClickFileUploadSelfie = this.ClickFileUploadSelfie.bind(this);
    this.FrontFileUpload = this.FrontFileUpload.bind(this);
    this.BackFileUpload = this.BackFileUpload.bind(this);
    this.resendOtp = this.resendOtp.bind(this);
    this.SelfieFileUpload = this.SelfieFileUpload.bind(this);
    this.RemoveFrontImage = this.RemoveFrontImage.bind(this);
    this.RemoveBackImage = this.RemoveBackImage.bind(this);
    this.RemoveSelfieImage = this.RemoveSelfieImage.bind(this);
    this.changeHandlerSelect = this.changeHandlerSelect.bind(this);
    this.editablePhone = this.editablePhone.bind(this);
    this.scrollTop = this.scrollTop.bind(this);
    this.changeHandlerPhone = this.changeHandlerPhone.bind(this);
    this.resetPasswordemail = this.resetPasswordemail.bind(this);
    this.getAgreementdata = this.getAgreementdata.bind(this);
    this.getclientToken = this.getclientToken.bind(this);
    this.houseRuleChangeHandler = this.houseRuleChangeHandler.bind(this);
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    // await this.getAgreementdata();
    // Agreement already signed (is_form_submited=2) but card not yet saved â€”
    // skip steps 1-4 and jump straight to the card tokenization screen.
    if (
      this.state.is_form_submited == 2 &&
      this.state.card_tokenise == 0 &&
      this.state.isCardEnable == 1 &&
      this.state.Datecheck == false
    ) {
      this.setState({ pagestate: 6 });
      this.getclientToken("", this.state.card_agree_type);
    }
  }

  getclientToken = async (queryString = "", value) => {
    this.setState({ showSpinner: true, loading: true });
    var resData = {};
    var resDataArr = [];
    var stripe_id = [];
    var customer_id = [];
    var depositeType = [];
    var card_agree_type = 0;
    let inputData = {
      customer_id: this.state.currentData?.guest_user?.stripe_customer_id,
      guest_slug: this.state.currentData?.guest_user?.slug,
      reservation_slug: this.state.currentData?.slug,
      card_agree_type: value,
    };
    if (value == 1 || value == 2) {
      let res = await CmsDataService.getCardclientToken(inputData);
      if (global.successStatus.includes(res.status)) {
        resDataArr = res.data ? res.data[0] : [];
        stripe_id = res.data ? res.data[1] : [];
        customer_id = res.data ? res.data[2] : [];
        depositeType = res.data ? res.data[3] : [];
      }
    }
    if (depositeType == 50000) {
      card_agree_type = 1;
    } else {
      card_agree_type = 2;
    }
    await this.setState({
      clientToken: resDataArr,
      stripe_id: stripe_id,
      customer_id: customer_id,
      card_agree_type: card_agree_type,
    });
    this.getReservationDetailsForLocalStorage();
  };

  getReservationDetailsForLocalStorage = async () => {
    var list = [];
    this.setState({ loader: true });
    var data = {
      confirmation_code: this.state.confirmation_code,
      last_name: this.state.last_name,
      email: this.state.email,
      property_seo_slug: this.state.property_slug,
      user_slug: "",
      filter_by: 4,
    };
    let res = await ReservationService.getMyBookReservation(data);
    if (global.successStatus.includes(res.status) && res.data.length !== 0) {
      list = res.data ? res.data : [];
      await localStorage.setItem("trip_details", JSON.stringify(list));
    }
  };

  manageVerifyModal = (value = false) => {
    this.setState({ verifyOtpModal: value, clickAgain: false });
  };

  editablePhone = () => {
    this.setState({ editablePhone: !this.state.editablePhone });
  };

  scrollTop = () => {
    const section = document.querySelector("#PrivateSwitchBase-input");
    section.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "nearest",
    });
  };

  scrollTopemail = () => {
    const section = document.querySelector("#PrivateSwitchBase-input-email");
    section.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "nearest",
    });
  };

  togglePassword = () => {
    this.setState({ passwordType: "text" });
  };

  togglePasswordHide = () => {
    this.setState({ passwordType: "password" });
  };

  passwordCheckFun = () => {
    let errors = this.state.error;
    let passwordCheck = global.OnKeyPressEvent.validatePassword(
      this.state.password
    );
    if (passwordCheck !== "") {
      errors.password = passwordCheck;
    } else {
      errors.password = "";
    }
    this.setState({ error: errors });
  };

  resendOtp = async () => {
    this.setState({ loader: true });
    if (!this.state.email) {
      this.setState({
        email_error: "Please enter valid email.",
      });
    } else {
      var inputData = {
        user_token: this.state.user_token,
      };
      let res = await ReservationService.resendOtp(inputData);
      var phone_number = "";
      var otp = "";
      if (global.successStatus.includes(res.status)) {
        otp = res.data && res.data.otp ? res.data.otp : "";
        this.setState({
          otp: otp,
          verifyOtpModal: true,
          phone_number_error: "",
        });
      }
    }
    this.setState({ loader: false });
  };

  getAgreementdata = async () => {
    let res = await ReservationService.getGuestformcheckboxdata();
    if (global.successStatus.includes(res.status)) {
      this.setState({
        guest_checkbox_data: res,
      });
    }
    this.setState({ loader: false });
  };

  verifyOtp = async () => {
    this.setState({ loader: true });
    if (!this.state.verify_otp || this.state.verify_otp.length !== 6) {
      this.setState({
        verify_otp_error: "Please enter valid code to continue.",
      });
    } else {
      this.setState({ verify_otp_error: "" });
      var inputData = {
        user_token: this.state.user_token,
        otp: this.state.verify_otp,
      };
      let res = await ReservationService.verifyOtp(inputData);
      if (global.successStatus.includes(res.status)) {
        let inputDatanew = {
          guest_slug: this.state.guest_slug,
          confirmation_code: this.state.confirmation_code,
          sort_order: this.state.sort_order,
          email_verified: 1,
          is_form_submited: 0,
          status_id: 1,
        };

        let res = await ReservationService.Guestform(inputDatanew);
        if (global.successStatus.includes(res.status)) {
          localStorage.setItem("is_form_submited", 0);
          localStorage.setItem("is_email_verified", 1);
          this.setState({ is_email_verified: 1 });
        } else {
          if (res.data.result.errorDetail) {
            let errors = {};
            res.data.errorCode = "Validation Failed";
            res.data.result.errorDetail.forEach((item) => {
              errors[item.errorField] = item.errorMessage[0];
              res.data.errorMessage = "";
            });
            this.setState({ errors: errors });
          }
        }
        await this.setState({
          otp_verified_submit: true,
          verifyOtpModal: false,
          verify_otp: "",
          otp: "",
          pagestate: this.state.pagestate + 1,
        });
        // this.props.history.push(global.themeUrl + this.state.property_slug + "/book-tour-basic-info"+this.state.queryString);
      } else {
        this.setState({
          verify_otp_error:
            "Your OTP token has been expired or invalid. Please try to resent it.",
          resendOtp: true,
        });
      }
    }
    this.setState({ loader: false });
  };

  sendOtp = async () => {
    var inputData = {
      country_code: this.state.country_code,
      email: this.state.email,
      user_token: this.state.user_token,
      otp_type: this.state.otp_type,
    };
    let res = await ReservationService.sendOtp(inputData);
    var phone_number = "";
    var otp = "";
    if (global.successStatus.includes(res.status)) {
      phone_number =
        res.data && res.data.mobilePhone ? res.data.mobilePhone : "";
      otp = res.data && res.data.otp ? res.data.otp : "";
      this.setState({
        display_email: phone_number,
        otp: otp,
        verifyOtpModal: true,
        email_error: "",
      });
    }
    this.setState({ loader: false });
  };

  getReservationDetails = async () => {
    var list = [];
    var record = [];
    var totalRecords = 0;
    var password = "";
    if (this.state.passwordflag == 0) {
      var password = this.state.password;
    }
    this.setState({ loader: true });
    var captcha = true;
    var data = {
      confirmation_code: this.state.confirmation_code,
      last_name: this.state.last_name,
      password: password,
      email: this.state.email,
      phone_number: this.state.phone_number,
      property_seo_slug: this.state.property_slug,
      user_slug: "",
      filter_by: 4,
    };
    let res = await ReservationService.getMyBookReservation(data);
    if (global.successStatus.includes(res.status) && res.data.length !== 0) {
      list = res.data ? res.data : [];
      record = res.data ? res.data : [];
      this.setState({ loader: false });
      totalRecords = res.data ? res.data.total : 0;
    }
    if (this.state.errorCount >= 3) {
      recaptchaRef.current.reset();
    }
    if (global.successStatus.includes(res.status) && res.data.length !== 0) {
      let statusText = "pending";

      const currentDate = new Date();
      var dateFrom = Moment(record.checkin_date).format("MM/DD/YYYY");
      var dateTo = Moment(record.checkout_date).format("MM/DD/YYYY");
      var dateCheck = Moment(currentDate).format("MM/DD/YYYY");
      var d1 = dateFrom.split("/");
      var d2 = dateTo.split("/");
      var c = dateCheck.split("/");
      if (record.status_id === 1 && c >= d1 && c <= d2) {
        statusText = "Confirmed";
      } else if (
        record.status_id !== 2 &&
        record.set_channel === 1 &&
        record.payment_status === 2 &&
        dateCheck > dateTo
      ) {
        statusText = "Confirmed";
      } else if (
        record.status_id !== 2 &&
        record.set_channel === 2 &&
        dateCheck > dateTo
      ) {
        statusText = "Completed";
      } else {
        if (record.set_channel === 1) {
          statusText =
            record.cancel_status === 0 && record.payment_status === 2
              ? "Confirmed"
              : record.cancel_status === 0 && record.status_id === 1
              ? "Payment Pending"
              : record.cancel_status === 1
              ? "Cancelled"
              : "Failed";
        }
        if (record.set_channel === 2) {
          statusText =
            record.status_id === 1 || record.cancel_status === 0
              ? "Confirmed"
              : "Failed";
        }
      }
      record.status_text = statusText;
      record.baged_class =
        statusText === "Confirmed"
          ? "baged-confirm"
          : statusText === "Confirmed"
          ? "baged-pending"
          : statusText === "Cancelled"
          ? "baged-cancel"
          : statusText === "Completed"
          ? "baged-completed"
          : statusText === "Failed"
          ? "baged-cancel"
          : "baged-cancel";
      record.total_night_text =
        "$" +
        parseFloat(record.nightly_rate) +
        " x " +
        (record.total_stay_nights
          ? record.total_stay_nights > 1
            ? record.total_stay_nights + " nights"
            : "1 night"
          : "1 night");
      record.total_nightly_rate_disp =
        "$" +
        parseFloat(record.nightly_rate) * parseInt(record.total_stay_nights);
      await this.setState({
        total_record: totalRecords,
        reservationList: list,
        // Keep currentData in sync with the freshest fetch -- Step 2's dynamic
        // house rules (and every other currentData-derived field) must reflect
        // the latest property config, not the snapshot taken at construction.
        currentData: list,
        maxVehicle: parseInt(list?.maxVehicle) || 1,
        maxPet: parseInt(list?.max_pets_allowed) || 5,
        loader: false,
      });
      await localStorage.setItem("trip_details", JSON.stringify(list));
      this.setState({ reservationDetail: true, errorMsg: "" });
    }
  };

  changeHandlerSelect = async (event) => {
    let input = this.state.input;
    input.id_type = event.target.value;
    await this.setState({
      id_type: event.target.value,
      input: input,
      id_error: "",
    });
  };

  ClickFileUploadFront(el) {
    document.getElementById("img_eventTarget").click();
  }

  ClickFileUploadBack(el) {
    document.getElementById("img_eventTarget_back").click();
  }

  ClickFileUploadSelfie(el) {
    document.getElementById("img_eventTarget_selfie").click();
  }

  RemoveFrontImage = () => {
    this.setState({
      guestFrontimageUrl: "",
    });
  };

  RemoveBackImage = () => {
    this.setState({
      guestbackimageUrl: "",
    });
  };

  RemoveSelfieImage = () => {
    this.setState({
      guestselfieimageUrl: "",
    });
  };

  onSubmit = async (e) => {
    e.preventDefault();
    if (this.state.id_type === "" || this.state.id_type === undefined) {
      this.setState({ id_error: "Please select ID type" });
      return false;
    }
    // if(this.state.set_channel !== 1 && this.state.id_type !== "" &&  this.state.guestFrontimageUrl !== "" && this.state.guestbackimageUrl!=="" && this.state.guestselfieimageUrl!== ""){
    //  await this.resetPasswordemail();
    // }
    if (
      this.state.error.email === "" &&
      this.state.email !== "" &&
      this.state.guestFrontimageUrl !== "" &&
      this.state.guestbackimageUrl !== "" &&
      this.state.guestselfieimageUrl !== "" &&
      this.state.id_type !== ""
    ) {
      this.setState({ submitloader: true });
      let inputData = {
        guest_slug: this.state.guest_slug,
        signature_name: this.state.signature,
        confirmation_code: this.state.confirmation_code,
        front_photo_name: this.state.guestFront,
        back_photo_name: this.state.guestBack,
        selfie_photo_name: this.state.guestSelfie,
        id_type: this.state.id_type,
        sort_order: this.state.sort_order,
        email_verified: 1,
        // Legacy reservations (Datecheck=true) are marked fully complete (1) â€”
        // they have no card step. New reservations use 2 (agreement done, card pending).
        is_form_submited: this.state.Datecheck === true ? 1 : 2,
        card_tokenise: this.state.Datecheck === true ? 1 : 0,
        status_id: 1,
      };

      let res = await ReservationService.Guestform(inputData);
      if (global.successStatus.includes(res.status)) {
        localStorage.setItem("is_form_submited", 2);
        if (this.state.card_tokenise == 0 && this.state.isCardEnable == 1 && this.state.Datecheck === false) {
          this.getclientToken("", this.state.card_agree_type);
        }
        if (this.isAddOnsStepApplicable()) {
          this.setState({ pagestate: 5 });
        } else if (this.state.card_tokenise == 0 && this.state.isCardEnable == 1 && this.state.Datecheck === false) {
          this.setState({ pagestate: 6 });
        } else {
          window.location.href = "/reservation-details";
        }
      } else {
        if (res.data.result.errorDetail) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
      }
      this.setState({ submitloader: false });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } else {
      this.setState({ errors: "Please upload required images" });
    }
  };

  FrontFileUpload = async (event) => {
    if (event.target.files[0] !== undefined) {
      this.setState({ forntphoto_loader: true });
      const fileData = new FormData();
      fileData.append(
        "front_guest",
        event.target.files[0],
        event.target.files[0].name
      );
      fileData.append(
        "resizeOptions",
        "width:240,height:240,maintainAspectRatio:true,resizeDestinationFolder:thumb||width:480,height:480,maintainAspectRatio:false,resizeDestinationFolder:medium||width:720,height:720,maintainAspectRatio:false,resizeDestinationFolder:large-720||width:1200,height:1200,maintainAspectRatio:false,resizeDestinationFolder:large-1200"
      );
      fileData.append("mediaType", "1");
      fileData.append("orgFileDestinationFolder", "guest_user_front");
      fileData.append("fieldName", "front_guest");
      fileData.append("uploadOn", "presigned_url");
      fileData.append("slug", this.state.guest_slug);
      fileData.append("refTableId", "18");
      fileData.append("displayFileName", "guestFront");
      fileData.append("documentTypeSlug", this.state.guest_slug);
      fileData.append("description", "");
      fileData.append("documentTypeSlug", this.state.guest_slug);
      fileData.append("description", "");
      fileData.append("propertySlug", "");
      fileData.append("h1", "");
      fileData.append("h2", "");
      fileData.append("sortOrder", "");
      fileData.append("statusId", 1);
      let res = await AuthenticationService.uploadFrontImage(fileData);
      if (global.successStatus.includes(res.status)) {
        this.setState({
          guestFront: res.data.newName,
          guestFrontimageUrl: res.data.url,
          errors: "",
          imgError: "",
        });
        this.setState({ updateDisableButton: false });
        this.setState({ forntphoto_loader: false });
      } else {
        this.setState({ updateDisableButton: false });
        this.setState({ imgError: res.data.message });
        this.setState({ forntphoto_loader: false });
      }
    }
  };

  BackFileUpload = async (event) => {
    if (event.target.files[0] !== undefined) {
      this.setState({ backphtoto_loader: true });
      const fileData = new FormData();
      fileData.append(
        "back_guest",
        event.target.files[0],
        event.target.files[0].name
      );
      fileData.append(
        "resizeOptions",
        "width:240,height:240,maintainAspectRatio:true,resizeDestinationFolder:thumb||width:480,height:480,maintainAspectRatio:false,resizeDestinationFolder:medium||width:720,height:720,maintainAspectRatio:false,resizeDestinationFolder:large-720||width:1200,height:1200,maintainAspectRatio:false,resizeDestinationFolder:large-1200"
      );
      fileData.append("mediaType", "1");
      fileData.append("orgFileDestinationFolder", "guest_user_back");
      fileData.append("fieldName", "back_guest");
      fileData.append("uploadOn", "presigned_url");
      fileData.append("slug", this.state.guest_slug);
      fileData.append("refTableId", "18");
      fileData.append("displayFileName", "guestback");
      fileData.append("documentTypeSlug", this.state.guest_slug);
      fileData.append("description", "");
      fileData.append("documentTypeSlug", this.state.guest_slug);
      fileData.append("description", "");
      fileData.append("propertySlug", "");
      fileData.append("h1", "");
      fileData.append("h2", "");
      fileData.append("sortOrder", "");
      fileData.append("statusId", 1);
      // NOTE: uploadFrontImage is reused for all three ID photo types â€” there is no separate back/selfie endpoint.
      let res = await AuthenticationService.uploadFrontImage(fileData);
      if (global.successStatus.includes(res.status)) {
        this.setState({
          guestBack: res.data.newName,
          guestbackimageUrl: res.data.url,
          errors: "",
          imgError: "",
        });
        this.setState({ updateDisableButton: false });
        this.setState({ backphtoto_loader: false });
      } else {
        this.setState({ updateDisableButton: false });
        this.setState({ imgError: res.data.message });
        this.setState({ backphtoto_loader: false });
      }
    }
  };

  SelfieFileUpload = async (event) => {
    if (event.target.files[0] !== undefined) {
      this.setState({ selfiephoto_loader: true });
      const fileData = new FormData();
      fileData.append(
        "selfie_guest",
        event.target.files[0],
        event.target.files[0].name
      );
      fileData.append(
        "resizeOptions",
        "width:240,height:240,maintainAspectRatio:true,resizeDestinationFolder:thumb||width:480,height:480,maintainAspectRatio:false,resizeDestinationFolder:medium||width:720,height:720,maintainAspectRatio:false,resizeDestinationFolder:large-720||width:1200,height:1200,maintainAspectRatio:false,resizeDestinationFolder:large-1200"
      );
      fileData.append("mediaType", "1");
      fileData.append("orgFileDestinationFolder", "guest_user_selfie");
      fileData.append("fieldName", "selfie_guest");
      fileData.append("uploadOn", "presigned_url");
      fileData.append("slug", this.state.guest_slug);
      fileData.append("refTableId", "18");
      fileData.append("displayFileName", "guestSelfie");
      fileData.append("documentTypeSlug", this.state.guest_slug);
      fileData.append("description", "");
      fileData.append("documentTypeSlug", this.state.guest_slug);
      fileData.append("description", "");
      fileData.append("propertySlug", "");
      fileData.append("h1", "");
      fileData.append("h2", "");
      fileData.append("sortOrder", "");
      fileData.append("statusId", 1);
      let res = await AuthenticationService.uploadFrontImage(fileData);
      if (global.successStatus.includes(res.status)) {
        this.setState({
          guestSelfie: res.data.newName,
          guestselfieimageUrl: res.data.url,
          errors: "",
          imgError: "",
        });
        this.setState({ updateDisableButton: false });
        this.setState({ selfiephoto_loader: false });
      } else {
        this.setState({ updateDisableButton: false });
        this.setState({ imgError: res.data.message });
        this.setState({ selfiephoto_loader: false });
      }
    }
  };

  setNext = async (e) => {
    if (this.state.pagestate === 1 && this.state.email === "") {
      this.scrollTopemail();
      this.setState({ email_error: "Please enter valid email" });
      return false;
    }
    if (
      this.state.pagestate === 1 &&
      this.state.set_channel !== 1 &&
      this.state.lock_type === 2 &&
      this.state.is_latch_enable == 1 &&
      (this.state.password === "" || this.state.password === null)
    ) {
      let errors = this.state.error;
      let passwordCheck = global.OnKeyPressEvent.validatePassword(
        this.state.password
      );
      if (passwordCheck !== "") {
        errors.password = "please enter valid password";
      } else {
        errors.password = "";
      }
      this.setState({ error: errors });
      return false;
    }
    if (
      this.state.pagestate === 3 &&
      this.state.signature === "" &&
      this.state.is_notification_16 === ""
    ) {
      this.setState({
        signature_error: "Please enter valid signature",
        is_notification_16: false,
      });
      this.scrollTop();
      var pagestate = this.state.pagestate;
      await this.setState({ nextpagestate: pagestate });
      return false;
    }
    if (this.state.pagestate === 3 && this.state.is_notification_16 === false) {
      this.scrollTop();
      return false;
    }

    // Non-Airbnb guest on step 1 whose email is not yet verified:
    // trigger OTP flow instead of advancing â€” wizard stays on step 1 until OTP modal is confirmed.
    if (
      this.state.pagestate === 1 &&
      this.state.set_channel !== 1 &&
      this.state.otp_verified_submit === false &&
      this.state.is_email_verified == 0 &&
      !this.state.error.password
    ) {
      e.preventDefault();
      this.setState({ clickAgain: true });
      await this.getReservationDetails();
      await this.sendOtp();
      var pagestate = this.state.pagestate;
      await this.setState({ nextpagestate: pagestate, passwordflag: 1 });
      return false;
    }
    // Non-Airbnb guest on step 1 with verified email â€” advance to step 2.
    if (
      this.state.pagestate === 1 &&
      this.state.set_channel !== 1 &&
      this.state.email !== "" &&
      this.state.email_error === "" &&
      !this.state.error.password
    ) {
      this.setState({ clickAgain: true });
      await this.getReservationDetails();
      var pagestate = this.state.pagestate;
      await this.setState({ pagestate: pagestate + 1, passwordflag: 1 });
      window.scrollTo(0, 0);
    }
    if (
      this.state.pagestate === 1 &&
      this.state.set_channel === 1 &&
      this.state.email !== "" &&
      this.state.email_error === ""
    ) {
      await this.getReservationDetails();
      var pagestate = this.state.pagestate;
      await this.setState({ pagestate: pagestate + 1 });
    } else {
      // Pre-populate any not-yet-touched dynamic house rule to "unchecked" (false),
      // same semantics as the old is_notification_1..14 fields (key absent = untouched).
      let dynamicHouseRules =
        this.state.currentData?.property?.dynamic_house_rules || [];
      let houseRuleAgreements = { ...this.state.houseRuleAgreements };
      let hasUntouched = false;
      dynamicHouseRules.forEach((rule) => {
        if (houseRuleAgreements[rule.slug] === undefined) {
          houseRuleAgreements[rule.slug] = false;
          hasUntouched = true;
        }
      });
      if (hasUntouched) {
        await this.setState({
          houseRuleAgreements: houseRuleAgreements,
          classbox: "checkbox_valid",
        });
      }
    }
    // Step 2 gate: all required dynamic house rules must be ticked before advancing.
    if (this.state.pagestate === 2) {
      await this.setState({ is_submit: true });
      let dynamicHouseRules =
        this.state.currentData?.property?.dynamic_house_rules || [];
      let allRequiredAgreed = dynamicHouseRules
        .filter((rule) => rule.is_required)
        .every((rule) => this.state.houseRuleAgreements[rule.slug] === true);
      if (allRequiredAgreed) {
        var pagestate = this.state.pagestate;
        await this.setState({ pagestate: pagestate + 1 });
        window.scrollTo(0, 0);
      } else {
        await this.setState({ is_submit: false });
      }
    } else {
      if (this.state.pagestate === 3 && this.state.is_notification_16 === "") {
        await this.setState({ is_notification_16: false });
        this.scrollTop();
      }
      if (
        this.state.pagestate === 3 &&
        this.state.is_notification_16 &&
        this.state.signature !== ""
      ) {
        await this.setState({ pagestate: 4 });
        window.scrollTo(0, 0);
      }
      if (
        this.state.pagestate === 3 &&
        this.state.otp_verified_submit === true
      ) {
        await this.setState({ pagestate: 4 });
        window.scrollTo(0, 0);
      }
    }
  };

  setPrevious = async () => {
    var pagestate = this.state.pagestate;
    if (pagestate === 6) {
      await this.setState({ pagestate: this.isAddOnsStepApplicable() ? 5 : 4, passwordflag: 1 });
    } else {
      await this.setState({ pagestate: pagestate - 1, passwordflag: 1 });
    }
    window.scrollTo(0, 0);
    this.setState({ clickAgain: false });
  };

  changeHandler = (event) => {
    let input = this.state.input;
    let value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    // if(event.target.type=== "checkbox" && event.target.name === "is_notification"){
    //   this.setState({ property_check: true });
    // }
    // if(this.state.pagestate=== 2 && event.target.name !== "is_notification_15" && event.target.checked === false){
    //   this.setState({is_notification_15:false});
    // }
    // if(this.state.pagestate=== 2 && event.target.type === "checkbox" && event.target.checked===true && event.target.name === "is_notification_15"){
    //   this.setState({is_notification_1:true,
    //     is_notification_2:true,
    //     is_notification_3:true,
    //     is_notification_4:true,
    //     is_notification_5:true,
    //     is_notification_6:true,
    //     is_notification_7:true,
    //     is_notification_8:true,
    //     is_notification_9:true,
    //     is_notification_10:true,
    //     is_notification_11:true,
    //     is_notification_12:true,
    //     is_notification_13:true,
    //     is_notification_14:true})
    // }
    // if(this.state.pagestate=== 2 && event.target.type === "checkbox" && event.target.checked === false && event.target.name === "is_notification_15"){
    //   this.setState({is_notification_1:false,
    //     is_notification_2:false,
    //     is_notification_3:false,
    //     is_notification_4:false,
    //     is_notification_5:false,
    //     is_notification_6:false,
    //     is_notification_7:false,
    //     is_notification_8:false,
    //     is_notification_9:false,
    //     is_notification_10:false,
    //     is_notification_11:false,
    //     is_notification_12:false,
    //     is_notification_13:false,
    //     is_notification_14:false})
    // }
    // if (event.target.name === "email") {
    //   if (event.target.value.length > 8) {
    //     this.setState({ email_error: "" });
    //   }
    // }
    // if (event.target.name === "signature") {
    //   if (event.target.value ===  "") {
    //     this.setState({ signature_error: "Please enter valid signature" });
    //   } else{
    //     this.setState({ signature_error: "" });
    //   }
    // }

    // if (event.target.name === "email") {
    //   if (event.target.value.length > 7) {
    //     const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    //     if (regex.test(event.target.value) === false ) {
    //       var email_error = "Please enter valid email.";
    //       this.setState({ email_error: email_error });
    //     } else {
    //       var email_error = "";
    //       this.setState({ email_error: email_error });
    //     }
    //   }
    // }
    //input[event.target.name] = value;
    if (event.target.name === "password") {
      if (event.target.value.length > 1) {
        var errors = this.state.error;
        errors.password = "";
        this.setState({ error: errors });
      }
    }
    this.setState({ [event.target.name]: value, input: input });
  };

  // Dedicated handler for the dynamic Step 2 house-rule checkboxes, keyed by
  // property_house_rules.slug -- kept separate from changeHandler above since
  // that one is shared by many unrelated fields across this file.
  houseRuleChangeHandler = (event, slug) => {
    let houseRuleAgreements = { ...this.state.houseRuleAgreements };
    houseRuleAgreements[slug] = event.target.checked;
    this.setState({ houseRuleAgreements: houseRuleAgreements });
  };

  // Preserves line breaks in an admin-authored rule (e.g. a multi-line "Additional
  // House Rules" entry) without dangerouslySetInnerHTML -- plain text nodes only.
  renderRuleText = (ruleText) => {
    let lines = (ruleText || "").split(/\r\n|\r|\n/);
    return lines.map((line, index) => (
      <React.Fragment key={index}>
        {index > 0 ? <br /> : null}
        {line}
      </React.Fragment>
    ));
  };

  changeHandlerDeposite = (event) => {
    let input = this.state.input;
    let value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    this.setState({
      [event.target.name]: value,
      input: input,
      card_agree_type: value,
    });
    if (value == 2 || value == 1) {
      this.updateStripeIntent(value);
    }
  };

  updateStripeIntent = async (value) => {
    let inputData = {
      stripe_id: this.state.stripe_id,
      card_agree_type: value,
      confirmation_code: this.state.confirmation_code,
    };
    let res = await CmsDataService.updateIntentStripeCard(inputData);
  };

  resetPasswordemail = async () => {
    var inputData = {
      email: this.state.email,
    };
    let res = await ReservationService.SendpasswordLink(inputData);
    if (global.successStatus.includes(res.status)) {
    } else {
      this.setState({ pagestate: this.state.pagestate });
    }
    this.setState({ loader: false });
  };

  changeHandlerPhone = (phoneNumber) => {
    this.setState({ phone_number: phoneNumber });
    if (phoneNumber.length > 8) {
      var errors = this.state.error;
      errors.phone_number = "";
      this.setState({ error: errors });
    }

    if (phoneNumber.length > 1) {
      var errors = this.state.error;
      errors.phone_number = "";
      this.setState({ error: errors });
    }
    if (phoneNumber.length > 15 || phoneNumber.length < 8) {
      var errors = this.state.error;
      errors.phone_number = "The phone number must be a valid phone number";
      this.setState({ error: errors });
    }
  };

  changeHandlerSignature = (event) => {
    let value = event.target.value;
    let input = this.state.input;
    if (event.target.name === "signature") {
      if (event.target.value === "") {
        this.setState({ signature_error: "Please enter valid signature" });
      } else {
        this.setState({ signature_error: "" });
      }
    }
    input[event.target.name] = value;
    this.setState({
      [event.target.name]: value,
      input: input,
      signature: value,
    });
  };

  changeHandlerEmail = (event) => {
    let value = event.target.value;
    let input = this.state.input;
    if (event.target.name === "email") {
      if (event.target.value.length > 8) {
        this.setState({ email_error: "" });
      }
    }
    if (event.target.name === "signature") {
      if (event.target.value === "") {
        this.setState({ signature_error: "Please enter valid signature" });
      } else {
        this.setState({ signature_error: "" });
      }
    }

    if (event.target.name === "email") {
      if (event.target.value.length > 7) {
        const regex =
          /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if (regex.test(event.target.value) === false) {
          var email_error = "Please enter valid email.";
          this.setState({ email_error: email_error });
        } else {
          var email_error = "";
          this.setState({ email_error: email_error });
        }
      }
    }
    input[event.target.name] = value;
    this.setState({ [event.target.name]: value, input: input, email: value });
  };

  validateEmail = () => {
    var result = global.OnKeyPressEvent.validateEmail(this.state.email);
    if (!result) {
      this.setState({ email_error: "Please enter valid email." });
    } else {
      this.setState({ email_error: "" });
    }
    console.log("validate");
  };

  checkValidation = () => {
    let validation = true;
    let error = this.state.error;

    if (this.state.password === "") {
      error.password = "Please enter valid password.";
      validation = false;
    } else {
      let passwordCheck = global.OnKeyPressEvent.validatePassword(
        this.state.password
      );
      if (passwordCheck !== "") {
        error.password = passwordCheck;
        validation = false;
      }
    }

    this.setState({ error: error });
    return validation;
  };

  isParkingApplicable() {
    const { currentData, parking_payment } = this.state;
    const fee = currentData?.property_parking_fee;
    // null/undefined means property has no parking; "0.00" means free parking
    let _isParkingApplicable = fee !== null && fee !== undefined && fee !== "" && parking_payment != 1;
    return _isParkingApplicable
  }

  isPetCleaningApplicable() {
    const { currentData, pet_cleaning_payment } = this.state;
    return (
      currentData?.bypass_pet_cleaning_payment != 1 &&
      pet_cleaning_payment != 1 &&
      parseFloat(currentData?.pet_cleaning_fee_stripe) > 0
    );
  }

  isAddOnsStepApplicable() {
    return this.isParkingApplicable() || this.isPetCleaningApplicable();
  }

  incrementPet = () => {
    const { no_of_pet, maxPet } = this.state;
    if (no_of_pet < maxPet) this.setState({ no_of_pet: no_of_pet + 1 });
  };

  decrementPet = () => {
    const { no_of_pet } = this.state;
    if (no_of_pet > 1) this.setState({ no_of_pet: no_of_pet - 1 });
  };

  incrementVehicle = () => {
    const { no_of_vehicle, maxVehicle, vehicleDetails } = this.state;
    if (no_of_vehicle < maxVehicle) {
      this.setState({
        no_of_vehicle: no_of_vehicle + 1,
        vehicleDetails: [...vehicleDetails, { vehicle_make: "", vehicle_model: "", vehicle_color: "", license_plate_number: "" }],
      });
    }
  };

  decrementVehicle = () => {
    const { no_of_vehicle, vehicleDetails } = this.state;
    if (no_of_vehicle > 1) {
      this.setState({
        no_of_vehicle: no_of_vehicle - 1,
        vehicleDetails: vehicleDetails.slice(0, -1),
      });
    }
  };

  onAddOnsContinue = async () => {
    const { petCleaningEnabled, parkingEnabled } = this.state;
    if (!petCleaningEnabled && !parkingEnabled) {
      if (this.state.card_tokenise == 0 && this.state.isCardEnable == 1 && this.state.Datecheck === false) {
        this.setState({ pagestate: 6 });
      } else {
        window.location.href = "/reservation-details";
      }
      window.scrollTo(0, 0);
      return;
    }
    if (parkingEnabled) {
      this.setState({ addOnsSubstate: "vehicle-details", addOnsError: "" });
      return;
    }
    this.setState({ addOnsLoader: true, addOnsError: "" });
    await this.fetchAddOnsToken();
  };

  fetchAddOnsToken = async () => {
    const { currentData, petCleaningEnabled, parkingEnabled, no_of_pet, no_of_vehicle } = this.state;
    const items = [];
    if (petCleaningEnabled) items.push({ type: "pet_cleaning", quantity: no_of_pet });
    if (parkingEnabled)     items.push({ type: "parking",      quantity: no_of_vehicle });
    const inputData = {
      customer_id:      currentData?.guest_user?.stripe_customer_id,
      guest_slug:       currentData?.guest_user?.slug,
      reservation_slug: currentData?.slug,
      items,
    };
    try {
      const res = await CmsDataService.getTripAddonsClientToken(inputData);
      if (global.successStatus.includes(res?.status) && res?.data) {
        this.setState({
          addOnsClientSecret:      res.data.client_secret,
          addOnsStripeId:          res.data.payment_id,
          addOnsItems:             items,
          addOnsCalculatedAmounts: res.data.calculated_items,
          addOnsSubstate:          "payment",
          addOnsLoader:            false,
        });
      } else {
        this.setState({ addOnsError: "Unable to initialize payment. Please try again.", addOnsLoader: false });
      }
    } catch (e) {
      this.setState({ addOnsError: "Unable to initialize payment. Please try again.", addOnsLoader: false });
    }
  };

  onAddOnsPaymentSuccess = () => {
    const { addOnsItems } = this.state;
    if (addOnsItems.some(i => i.type === "pet_cleaning")) {
      localStorage.setItem("pet_cleaning_payment", "1");
      this.setState({ pet_cleaning_payment: "1" });
    }
    if (addOnsItems.some(i => i.type === "parking")) {
      localStorage.setItem("parking_payment", "1");
      this.setState({ parking_payment: "1" });
    }
    this.getReservationDetails();
    const nextState = {
      addOnsSubstate:     "summary",
      addOnsClientSecret: null,
      addOnsStripeId:     null,
      addOnsItems:        [],
    };
    if (this.state.card_tokenise == 0 && this.state.isCardEnable == 1 && this.state.Datecheck === false) {
      this.setState({ ...nextState, pagestate: 6 });
    } else {
      this.setState(nextState);
      window.location.href = "/reservation-details";
    }
    window.scrollTo(0, 0);
  };

  onAddOnsBack = () => {
    if (this.state.addOnsSubstate === "payment" && this.state.parkingEnabled) {
      this.setState({ addOnsSubstate: "vehicle-details", addOnsClientSecret: null, addOnsStripeId: null });
    } else {
      this.setState({ addOnsSubstate: "summary", addOnsClientSecret: null, addOnsStripeId: null, addOnsError: "" });
    }
  };

  onVehicleDetailChange = (index, field, value) => {
    const vehicleDetails = this.state.vehicleDetails.map((v, i) =>
      i === index ? { ...v, [field]: value } : v
    );
    this.setState({ vehicleDetails });
  };

  onVehicleDetailsContinue = async () => {
    this.setState({ addOnsLoader: true, addOnsError: "" });

    const { currentData, petCleaningEnabled, no_of_vehicle, vehicleDetails } = this.state;
    const parkingFeeTotal = parseFloat(currentData?.parking_fee_stripe || 0);

    if (parkingFeeTotal === 0 && !petCleaningEnabled) {
      const saveRes = await ReservationService.AddParkingData({
        confirmation_code: currentData?.confirmation_code,
        stripe_transaction_id: "",
        amount: 0,
        no_of_vehicle: no_of_vehicle,
        is_free_parking: 1,
      });
      if (global.successStatus.includes(saveRes?.status)) {
        await ReservationService.UpdateCarcolor({
          confirmation_code: currentData?.confirmation_code,
          vehicle_details: vehicleDetails,
        });
        this.setState(
          { addOnsItems: [{ type: "parking", quantity: no_of_vehicle }] },
          () => this.onAddOnsPaymentSuccess()
        );
      } else {
        this.setState({ addOnsError: "Unable to save parking. Please try again.", addOnsLoader: false });
      }
      return;
    }

    await this.fetchAddOnsToken();
  };

  render() {
    const options = {
      clientSecret: this.state.clientToken,
      appearance: {
        /*...*/
      },
    };
    const days = this.state.currentData
      ? this.state.currentData.total_stay_nights
      : "";
    const depositeTitle =
      this.state.currentData?.deposite_checkbox_title.replace(
        "[amount]",
        this.state.deposite_amount ? this.state.deposite_amount : ""
      );
    // const daysamount = days > 32 ? "Purchase a $60 damage waiver":"Purchase a $30 damage waiver";
    const daysamount =
      days > 32
        ? this.state.currentData?.waiver_checkbox_title.replace(
            "[amount]",
            "$60" ? "$60" : ""
          )
        : this.state.currentData?.waiver_checkbox_title.replace(
            "[amount]",
            "$30" ? "$30" : ""
          );
    const step1Content = (
      <>
        <div className="container-fluid p-0">
          <section className="wzrd_main_section">
            <div className="container">
              <div className="content">
                <div className="row mobView wizard_new_heading">
                  <div className="wzrd_middle_desk">
                    <div className="col-sm-12 col-lg-12 bg_wzrd_heading">
                      <div className="wzrd_heading_box col-12 ">
                        <p className="welcom_text_wzrd">
                          <strong>
                            Hi{" "}
                            {this.state.currentData.guest_user
                              ? this.state.currentData.guest_user.first_name
                              : "-"}
                            ,
                          </strong>{" "}
                          Please complete the Guest Agreement to access your
                          reservation and check-in details. You must complete
                          all sections or you won't be granted entry into the
                          apartment.
                        </p>
                      </div>
                    </div>
                    <div className="col-sm-12 col-lg-12 bg_wzrd_heading">
                      <div className="wzrd_heading_box col-12 m-0 scroll_phn_safari">
                        <div className="wizardInfo pt-0">
                          <h5>
                            {this.state.currentData.listing_name
                              ? this.state.currentData.listing_name
                              : ""}
                          </h5>
                          <p className="prop_wzd_loc">
                            <img src="https://d1xsfycladxeij.cloudfront.net/website/images/pin.svg" />{" "}
                            {this.state.currentData &&
                            this.state.currentData.property &&
                            this.state.currentData.property.state
                              ? this.state.currentData.property.state
                                  .state_name + ", "
                              : ""}
                            {this.state.currentData &&
                            this.state.currentData.property &&
                            this.state.currentData.property.country
                              ? this.state.currentData.property.country
                                  .country_name + "."
                              : ""}
                          </p>
                        </div>
                        <div class="wizard_timing mg-t-20">
                          <ul className="fst_wzd_list">
                            <li>
                              <strong>Check-in</strong>
                              <span class="checkdate-  d-block">
                                {" "}
                                {this.state.currentData.checkin_date
                                  ? Moment(
                                      this.state.currentData.checkin_date
                                    ).format("MM/DD/YY")
                                  : "-"}{" "}
                                |{" "}
                                {this.state.currentData
                                  ? this.state.currentData.property
                                      ?.check_in_time
                                  : ""}
                              </span>
                            </li>
                            <li>
                              <strong>Check-out</strong>
                              <span class="checkdate-  d-block">
                                {" "}
                                {this.state.currentData.checkout_date
                                  ? Moment(
                                      this.state.currentData.checkout_date
                                    ).format("MM/DD/YY")
                                  : "-"}{" "}
                                |{" "}
                                {this.state.currentData.property
                                  ? this.state.currentData.property
                                      .check_out_time
                                  : ""}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="wzrd_mid_heading">
                          <h5>Reservation details</h5>
                          <div class="wizard_timing">
                            <ul className="resr_detl_list">
                              <li>
                                <strong>Confirmation code</strong>
                                <span class="checkdate-  d-block">
                                  {" "}
                                  {this.state.currentData.confirmation_code
                                    ? this.state.currentData.confirmation_code
                                    : "-"}
                                </span>
                              </li>
                              <li>
                                <strong>No. of guests</strong>
                                <span class="checkdate-  d-block">
                                  {this.state.currentData.number_of_guest &&
                                  this.state.currentData.number_of_guest !==
                                    null
                                    ? this.state.currentData.number_of_guest
                                    : "-"}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="wzrd_mid_heading">
                          <h5>Your contact info</h5>
                          <div class="wizard_timing ">
                            <ul className="full_len pc_view_wzd">
                              <li className="">
                                <strong>Name</strong>
                                <span class="checkdate-  d-block">
                                  {this.state.currentData.guest_user
                                    ? this.state.currentData.guest_user
                                        .first_name +
                                      " " +
                                      this.state.last_name
                                    : "-"}
                                </span>
                              </li>
                              <li className="position-relative">
                                <strong>Mobile</strong>
                                <span class="checkdate-  d-block">
                                  {" "}
                                  <PhoneNumberFormat
                                    phone_number={this.state.phone_number}
                                  />
                                  <span class="edit_phone">
                                    <img
                                      src="https://did1d8jg9ar6w.cloudfront.net/website/images/edit-icon.svg"
                                      alt=""
                                      onClick={this.editablePhone}
                                    />
                                  </span>
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="wzrd_mid_heading border-0 wzrd_100b row mob_row_reserv pt-0">
                          <div className="col-xs-6 col-sm-6 col-md-6 pl-cust-two-0 wzrd_phone mg-b-15">
                            <div className="countryphone">
                              <TextField
                                margin="normal"
                                className=" textfield w-100 m-0"
                                required
                                fullWidth
                                value={this.state.email ? this.state.email : ""}
                                onBlur={() => this.validateEmail()}
                                onChange={this.changeHandlerEmail}
                                id="email"
                                label="Email"
                                name="email"
                                autoComplete="off"
                              />
                              <p className="error-message">
                                {this.state.email_error
                                  ? this.state.email_error
                                  : ""}
                              </p>
                            </div>
                          </div>

                          
                            <div className="col-xs-6 col-sm-6 col-md-6 pl-cust-0 wzrd_phone mg-b-15">
                              <PhoneInput
                                country={global.country}
                                onlyCountries={["us"]}
                                className={`textfield phoneInput ${!this.state.editablePhone ? "phone-disabled" : "phone-enabled"}`}
                                variant="outlined"
                                autoFormat="true"
                                enableSearch="true"
                                countryCodeEditable="true"
                                id="phone_number"
                                name="phone_number"
                                value={
                                  this.state.phone_number
                                    ? this.state.phone_number
                                    : ""
                                }
                                disableCountryCode={true}
                                disableDropdown={true}
                                onChange={(e) => this.changeHandlerPhone(e)}
                                error={
                                  this.state.error.phone_number ? true : false
                                }
                                helperText={
                                  this.state.error.phone_number
                                    ? this.state.error.phone_number
                                    : ""
                                }
                                placeholder="Phone number"
                                disabled={!this.state.editablePhone}
                                inputProps={{
                                  readOnly: !this.state.editablePhone,
                                }}
                                fullWidth
                              />
                            </div>

                        </div>
                        <div className="wzrd_mid_heading border-0 wzrd_100b row pt-0">
                          {this.state.passwordflag == 0 &&
                          this.state.set_channel !== 1 &&
                          this.state.lock_type == 2 &&
                          this.state.is_latch_enable == 1 ? (
                            <div className="col-xs-6 col-sm-6 col-md-6 pl-cust-two-0 wzrd_phone position-relative">
                              <div className="countryphone">
                                <TextField
                                  margin="normal"
                                  className="textfield phoneInput m-0"
                                  required
                                  fullWidth
                                  id="password"
                                  label="Password"
                                  name="password"
                                  type={this.state.passwordType}
                                  onBlur={() => this.passwordCheckFun()}
                                  onChange={this.changeHandler}
                                  error={
                                    this.state.error.password ? true : false
                                  }
                                  value={this.state.password}
                                  autocomplete="off"
                                  // autoComplete={false}
                                  // autoFocus
                                />
                                {this.state.passwordType === "password" ? (
                                  <span
                                    className="eye-icon"
                                    onClick={this.togglePassword}
                                  >
                                    {" "}
                                    <img src={openeye} alt="" />
                                  </span>
                                ) : (
                                  <span
                                    className="eye-icon"
                                    onClick={this.togglePasswordHide}
                                  >
                                    <img src={closeeye} alt="" />
                                  </span>
                                )}

                                {/* <span className="eye-icon">
                                  <img src={openeye} alt="" />
                                  <img src={closeeye} alt="" />
                                </span> */}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          <p className="error-message p-0">
                            {this.state.error.password
                              ? this.state.error.password
                              : ""}
                          </p>

                          {this.state.passwordflag == 0 &&
                          this.state.set_channel !== 1 &&
                          this.state.lock_type == 2 &&
                          this.state.is_latch_enable == 1 ? (
                            <div className="row align-items-start flex-nowrap pd-r-10 pd-l-10 mg-b-15 mg-t-15 text-align-left">
                              <div className="flex-wrap service_terms p-0">
                                <span className="agree">
                                  By selecting Next, I agree to OHAI's{" "}
                                  <a
                                    href={"/terms-condition"}
                                    title="Terms of Service"
                                    target="_blank"
                                  >
                                    {" "}
                                    Terms of Service{" "}
                                  </a>{" "}
                                  and{" "}
                                  <a
                                    href={"/privacy"}
                                    title="Privacy Policy"
                                    target="_blank"
                                  >
                                    {" "}
                                    Privacy Policy{" "}
                                  </a>
                                  .
                                </span>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <p
                        className="guest_last_checkin m-0"
                        id="PrivateSwitchBase-input-email"
                      ></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );

    const dynamicHouseRules =
      this.state.currentData?.property?.dynamic_house_rules || [];
    const step2Content = (
      <>
        <div className="container-fluid p-0">
          <section className="wzrd_main_section">
            <div className="container">
              <div className="content">
                <div className="row mobView wizard_new_heading">
                  <div className="wzrd_middle_desk">
                    <div className="col-sm-12 col-lg-12 bg_wzrd_heading mob_sticky_top">
                      <div className="wzrd_heading_box col-12 m-0">
                        <h4>House rules</h4>
                      </div>
                    </div>

                    <div className="pc_middle_wzd">
                      {dynamicHouseRules.map((rule) => (
                        <div className="col-sm-12 col-lg-12 bg_wzrd_heading " key={rule.slug}>
                          <div className="wzrd_heading_box col-12 mb-0">
                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 mg-b-0 check_wizard ">
                              {rule.is_required ? (
                                <span className="checkbox_valid_star">*</span>
                              ) : (
                                ""
                              )}
                              <p>
                                <FormGroup>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={
                                          !!this.state.houseRuleAgreements[rule.slug]
                                        }
                                        className="d-none"
                                      />
                                    }
                                    labelPlacement="end"
                                    label={this.renderRuleText(rule.rule_text)}
                                    required={!!rule.is_required}
                                    name={rule.slug}
                                    onChange={(e) =>
                                      this.houseRuleChangeHandler(e, rule.slug)
                                    }
                                    className="wizard_check"
                                  />
                                </FormGroup>
                              </p>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={
                                        !!this.state.houseRuleAgreements[rule.slug]
                                      }
                                    />
                                  }
                                  labelPlacement="end"
                                  label={rule.checkbox_text || "Yes, I agree"}
                                  required={!!rule.is_required}
                                  name={rule.slug}
                                  onChange={(e) =>
                                    this.houseRuleChangeHandler(e, rule.slug)
                                  }
                                  error={
                                    this.state.houseRuleAgreements[rule.slug]
                                      ? true
                                      : false
                                  }
                                  className="wizard_check"
                                />
                                <p className="error-message">
                                  {rule.is_required &&
                                  this.state.houseRuleAgreements[rule.slug] === false
                                    ? "Please agree to continue"
                                    : ""}
                                </p>
                              </FormGroup>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
    const agreement = this.state.currentData?.property?.accommodation_agreement;
    const step3Content = (
      <>
        <div className="container-fluid p-0">
          <section className="wzrd_main_section">
            <div className="container">
              <div className="content">
                <div className="row mobView wizard_new_heading ">
                  <div className="wzrd_middle_desk wzrd_middle_desk_new ">
                    <div className="col-sm-12 col-lg-12 bg_wzrd_heading mob_sticky_top">
                      <div className="wzrd_heading_box col-12 m-0">
                        <h4>{agreement?.title || "Guest accommodations agreement"}</h4>
                      </div>
                    </div>
                    <div className="pc_middle_wzd">
                      <div className="col-sm-12 col-lg-12 bg_wzrd_heading ">
                        <div className="wzrd_heading_box col-12 mb-0">
                          <div className="col-xs-12 col-sm-12 col-md-12 p-0 check_wizard scroll_phn_safari">
                            <p>Last updated on {agreement?.last_updated_on ? Moment(agreement.last_updated_on).format("MMMM DD, YYYY") : ""}</p>
                            <p>&nbsp;</p>
                            <p style={{textAlign:"justify"}}>
                                <strong>IN ORDER TO RECEIVE CHECK-IN INSTRUCTIONS ALL GUESTS MUST AGREE TO COMPLETE AND AGREE TO THIS GUEST
                                    ACCOMMODATIONS AGREEMENT AND OUR TERMS OF SERVICE (“TERMS”) LOCATED AT.
                                </strong>
                                    <a href="https://www.orionhaus.com/terms-condition" target="_blank">https://www.orionhaus.com/terms-condition</a>
                                <strong> 
                                  GUESTS WHO HAVE BOOKED AND DO NOT COMPLETE THE AGREEMENT WILL NOT RECEIVE A REFUND. TERMS CAPITALIZED BUT NOT
                                    DEFINED IN THIS GUEST ACCOMMODATIONS AGREEMENT SHALL HAVE THE MEANING ASCRIBED TO THEM IN OUR TERMS.
                                </strong>
                            </p>
                            <p style={{textAlign:"justify"}}>
                                OH Management USA, LLC (“Orion Haus”, “we”, “us”, “the Company”) is committed to being a great neighbor in our
                                communities. That’s why all Guests (“you,” <strong>{this.state.currentData.guest_user ? this.state.currentData.guest_user.first_name + " " + this.state.currentData.guest_user.last_name : "-"}</strong>, “your”) must agree to abide by our Terms
                                of Service (“Terms”,, this Guest Accommodation Agreement (the “Guest Accommodation Agreement”), Orion Haus’s Privacy
                                Policy, and all other applicable House Rules and Policies detailed below in consideration for your accommodation at
                                the Premises and the Property.
                            </p>
                            <p>&nbsp;</p>
                            <div
                              className="wzrd_agreement_body"
                              dangerouslySetInnerHTML={{
                                __html: agreement?.body_html || "",
                              }}
                            />

                          <p style={{textAlign:"justify"}}><strong>GUEST SIGNATURE:</strong></p>
                          <p style={{textAlign:"justify"}}>
                              By signing below, Guest acknowledges that they have read, understood, and agree to be bound by this Guest
                              Accommodations Agreement, the House Rules and Policies referenced herein, Orion Haus's Terms of Service, and
                              Privacy Policy.
                          </p>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={this.state.is_notification_16}
                                  />
                                }
                                labelPlacement="end"
                                label={agreement?.checkbox_text || "Yes, I agree to be a great guest"}
                                required={true}
                                name="is_notification_16"
                                onChange={(e) => this.changeHandler(e)}
                                error={
                                  this.state.is_notification_16 ? true : false
                                }
                                className="wizard_check"
                                helperText={
                                  this.state.is_notification_16
                                    ? this.state.is_notification_16
                                    : ""
                                }
                              />
                              <p className="error-message gust_lst_check">
                                {this.state.is_notification_16 === false
                                  ? "Please agree to continue"
                                  : ""}
                              </p>
                            </FormGroup>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-12 col-lg-12 bg_wzrd_heading sign_wzrd">
                        <div className="wzrd_heading_box m-0 pd-b-0-mob">
                          <div className="wzrd_mid_heading border-0 m-0 pb-0 pt-0">
                            <div className="col-xs-6 col-sm-6 col-md-6 ">
                              <div className="countryphone signamture_btm ">
                                <TextField
                                  margin="normal"
                                  className=" textfield w-100 m-0"
                                  required
                                  fullWidth
                                  value={
                                    this.state.signature
                                      ? this.state.signature
                                      : ""
                                  }
                                  onChange={this.changeHandlerSignature}
                                  id="signature"
                                  label="Signature"
                                  name="signature"
                                  autoComplete="off"
                                  error={
                                    this.state.signature_error ? true : false
                                  }
                                  helperText={
                                    this.state.signature_error
                                      ? this.state.signature_error
                                      : ""
                                  }
                                  // autoFocus
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        className="guest_last_checkin"
                        id="PrivateSwitchBase-input"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
    const step4Content = (
      <>
        <div className="container-fluid p-0">
          <section className="wzrd_main_section">
            <div className="container">
              <div className="content">
                <div className="row mobView wizard_new_heading">
                  <div className="wzrd_middle_desk">
                    <div className="col-sm-12 col-lg-12 bg_wzrd_heading mob_sticky_top">
                      <div className="wzrd_heading_box col-12 m-0">
                        <h4>Identity verification</h4>
                      </div>
                    </div>

                    <div className="col-sm-12 col-lg-12 bg_wzrd_heading ">
                      <div className="wzrd_heading_box col-12 mb-0">
                        <div className="col-xs-12 col-sm-12 col-md-12 p-0 mg-b-0 check_wizard upload_info_detail">
                          <div className="wzrd_mid_heading border-0 m-0 pt-0">
                            <div className="col-xs-6 col-sm-6 col-md-6 ">
                              <div className="countryphone">
                                <FormControl fullWidth>
                                  <InputLabel id="demo-simple-select-label">
                                    Select ID type
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Age"
                                    value={this.state.id_type}
                                    //disabled
                                    name="add"
                                    onChange={(event) =>
                                      this.changeHandlerSelect(event)
                                    }
                                  >
                                    <MenuItem value={1}>
                                      Driver's License
                                    </MenuItem>
                                    <MenuItem value={2}>Passport</MenuItem>
                                    <MenuItem value={3}>Other</MenuItem>
                                  </Select>
                                </FormControl>
                                <p className="error-message">
                                  {this.state.id_error
                                    ? this.state.id_error
                                    : ""}
                                </p>
                              </div>
                            </div>
                          </div>
                          <p>
                            {" "}
                            <b className="doc_upload_heading ">
                              Upload images of your identification
                            </b>{" "}
                          </p>
                          <ul>
                            <li>
                              <p>
                                Make sure your photos aren't blurry and the
                                front of your driver's license clearly shows
                                your face.
                              </p>
                            </li>
                            <li>
                              <p>
                                Please provide a selfie in which you hold your
                                government ID net to your face.
                              </p>
                            </li>
                            <li>
                              <p>
                                The purpose of this requirement is so that we
                                can confirm the person who booked our apartment
                                is in fact you.
                              </p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-12 col-lg-12 bg_wzrd_heading doc_upload_sec">
                      <div className="row wzrd_heading_box m-0 scroll_phn_safari">
                        <div className="col-lg-2"></div>
                        <div className="col-lg-4 col-sm-6 col-12 id_verf_mob">
                          <div className="id_screen_upd">
                            <div
                              className="upd_frnt_img"
                              onClick={this.ClickFileUploadFront}
                            >
                              <input
                                onChange={this.FrontFileUpload}
                                type="file"
                                name="front_image"
                                accept="image/png, image/jpg, image/jpeg,image/heic"
                                disabled={this.state.forntphoto_loader}
                                id="img_eventTarget"
                                capture="camera"
                              />
                              {this.state.forntphoto_loader === true ? (
                                <div className="mob_fullscreen">
                                  <SpinnerLoader />
                                </div>
                              ) : (
                                <>
                                  <img
                                    src={global.OnKeyPressEvent.getS3ImageUrl(
                                      "front-icon.svg"
                                    )}
                                    alt=""
                                  />
                                  <p>Upload front</p>
                                </>
                              )}
                            </div>
                            {this.state.guestFrontimageUrl ? (
                              <div className="upd_frnt_img_preview">
                                <span
                                  className="exp_img_close"
                                  onClick={this.RemoveFrontImage}
                                >
                                  {global.closee}
                                </span>
                                <img
                                  src={
                                    this.state.guestFrontimageUrl
                                      ? this.state.guestFrontimageUrl
                                      : ""
                                  }
                                  alt=""
                                />
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="id_screen_upd">
                            <div
                              className="upd_frnt_img"
                              onClick={this.ClickFileUploadBack}
                            >
                              <input
                                onChange={this.BackFileUpload}
                                type="file"
                                name="back_image"
                                accept="image/png, image/jpg, image/jpeg,image/heic"
                                disabled={this.state.backphtoto_loader}
                                id="img_eventTarget_back"
                                capture="camera"
                              />
                              {this.state.backphtoto_loader === true ? (
                                <div className="mob_fullscreen">
                                  <SpinnerLoader />
                                </div>
                              ) : (
                                <>
                                  {" "}
                                  <img
                                    src={global.OnKeyPressEvent.getS3ImageUrl(
                                      "back-icon.svg"
                                    )}
                                    alt=""
                                  />
                                  <p>Upload back</p>
                                </>
                              )}
                            </div>
                            {this.state.guestbackimageUrl ? (
                              <div className="upd_frnt_img_preview">
                                <span
                                  className="exp_img_close"
                                  onClick={this.RemoveBackImage}
                                >
                                  {global.closee}
                                </span>
                                <img
                                  src={
                                    this.state.guestbackimageUrl
                                      ? this.state.guestbackimageUrl
                                      : ""
                                  }
                                  alt=""
                                />
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>

                        <div className="col-lg-4 col-sm-6  col-xs-6 offset-xs-3 position-relative p-0">
                          <div
                            className="upd_frnt_img upd_frnt_img_sec"
                            onClick={this.ClickFileUploadSelfie}
                          >
                            <input
                              onChange={this.SelfieFileUpload}
                              type="file"
                              name="selfie_image"
                              accept="image/png, image/jpg, image/jpeg,image/heic"
                              disabled={this.state.selfiephoto_loader}
                              id="img_eventTarget_selfie"
                              capture="environment"
                            />
                            {this.state.selfiephoto_loader === true ? (
                              <div className="mob_fullscreen">
                                <SpinnerLoader />
                              </div>
                            ) : (
                              <>
                                {" "}
                                <img
                                  src={global.OnKeyPressEvent.getS3ImageUrl(
                                    "selfie.svg"
                                  )}
                                  alt=""
                                />
                                <p>Upload selfie holding ID</p>
                              </>
                            )}
                          </div>
                          {this.state.guestselfieimageUrl ? (
                            <div className="upd_frnt_img_preview_1">
                              <span
                                className="exp_img_close"
                                onClick={this.RemoveSelfieImage}
                              >
                                {global.closee}
                              </span>
                              <img
                                src={
                                  this.state.guestselfieimageUrl
                                    ? this.state.guestselfieimageUrl
                                    : ""
                                }
                                alt=""
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-lg-2"></div>
                        <div className="col-12 upload_test_box">
                          <p className="error-message text-center">
                            {this.state.guestFrontimageUrl === "" &&
                            this.state.guestbackimageUrl === "" &&
                            this.guestselfieimageUrl === ""
                              ? "Images are required"
                              : this.state.errors}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
    const addOnsOptions = {
      clientSecret: this.state.addOnsClientSecret,
      appearance: {},
    };
    const basePetAmount = parseFloat(this.state.currentData?.pet_cleaning_fee_stripe) || 0;
    const petTotal = Number((basePetAmount * this.state.no_of_pet).toFixed(2));
    const baseParkingAmount = this.state.currentData?.parking_fee_stripe || 0;
    const parkingPerNight = this.state.currentData?.property_parking_fee || 0;
    const totalNights = this.state.currentData?.total_stay_nights || 0;
    const parkingTotal = baseParkingAmount * this.state.no_of_vehicle;
    const grandTotal =
      (this.state.petCleaningEnabled ? petTotal : 0) +
      (this.state.parkingEnabled ? parkingTotal : 0);
    const step5Content = (
      <>
        <div className="container-fluid p-0">
          <section className="wzrd_main_section">
            <div className="container">
              <div className="content">
                <div className="row mobView wizard_new_heading">
                  <div className="wzrd_middle_desk">
                    <div className="col-sm-12 col-lg-12 bg_wzrd_heading mob_sticky_top">
                      <div className="wzrd_heading_box col-12 m-0">
                        <h4>Trip add-ons</h4>
                      </div>
                    </div>
                    <div className="pc_middle_wzd pc_middle_wzd--addons">
                      {this.state.addOnsSubstate === "summary" && (
                        <div className="col-sm-12 col-lg-12 bg_wzrd_heading">
                          <div className="wzrd_heading_box col-12 mb-0">

                            <p className="addons_subtitle">
                              Optional &mdash; add only what applies to your stay.
                            </p>

                            {/* Pet Cleaning Fee section */}
                            {this.isPetCleaningApplicable() && (
                              <div className="addons_fee_row">
                                <div className="addons_fee_header">
                                  <div className="addons_fee_info">
                                    <h5>Pet cleaning fee</h5>
                                    <p>${basePetAmount} per pet &middot; one-time cleaning for stays with pets</p>
                                  </div>
                                  <Switch
                                    checked={this.state.petCleaningEnabled}
                                    onChange={(e) => {
                                      const enabled = e.target.checked;
                                      const update = { petCleaningEnabled: enabled };
                                      if (enabled) {
                                        const reserved = parseInt(this.state.currentData?.pets) || 1;
                                        update.no_of_pet = Math.min(Math.max(reserved, 1), this.state.maxPet);
                                      }
                                      this.setState(update);
                                    }}
                                    color="default"
                                  />
                                </div>
                                {this.state.petCleaningEnabled && (
                                  <div className="addons_fee_details">
                                    <ul className="parking_pay_detail">
                                      <li>
                                        <span>${basePetAmount} per pet</span>
                                        <span>${basePetAmount}</span>
                                      </li>
                                      <li>
                                        <span>No. of pets</span>
                                        <div className="d-flex align-items-center countBtn">
                                          <span>
                                            <button
                                              type="button"
                                              onClick={this.decrementPet}
                                              disabled={this.state.no_of_pet <= 1}
                                            >
                                              <img
                                                src={global.OnKeyPressEvent.getS3ImageUrl("minus-icon.svg")}
                                                alt="Pet Count"
                                                title="Pet Count"
                                              />
                                            </button>
                                          </span>
                                          <span>{this.state.no_of_pet}</span>
                                          <span>
                                            <button
                                              type="button"
                                              onClick={this.incrementPet}
                                              disabled={this.state.no_of_pet >= this.state.maxPet}
                                            >
                                              <img
                                                src={global.OnKeyPressEvent.getS3ImageUrl("add-icon.svg")}
                                                alt="Pet Count"
                                                title="Pet Count"
                                              />
                                            </button>
                                          </span>
                                        </div>
                                      </li>
                                      <li className="parking_total_price">
                                        <span>Total (USD)</span>
                                        <span>${petTotal.toFixed(2)}</span>
                                      </li>
                                    </ul>
                                  </div>
                                )}
                              </div>
                            )}

                            {/* Parking Fee section */}
                           
                            <div className="addons_fee_row">
                              <div className="addons_fee_header">
                                <div className="addons_fee_info">
                                  <h5>{ this.isParkingApplicable() ? `Parking fee` : `Parking details`}</h5>
                                  {this.isParkingApplicable() ? (
                                    <p>{`${parkingPerNight}/night · includes parking access and instructions`}</p>
                                  ) : (
                                    <p>Includes parking access and instructions</p>
                                  )}
                                </div>
                                <Switch
                                  checked={this.state.parkingEnabled}
                                  onChange={(e) => this.setState({ parkingEnabled: e.target.checked })}
                                  color="default"
                                />
                              </div>
                              {this.state.parkingEnabled && (
                                <div className="addons_fee_details">
                                  <ul className="parking_pay_detail">
                                    {this.isParkingApplicable() && (
                                    <li>
                                      <span>${parkingPerNight} &times; {totalNights} nights</span>
                                      <span>${baseParkingAmount}</span>
                                    </li>
                                    )}
                                    <li>
                                      <span>No. of vehicles</span>
                                      <div className="d-flex align-items-center countBtn">
                                        <span>
                                          <button
                                            type="button"
                                            onClick={this.decrementVehicle}
                                            disabled={this.state.no_of_vehicle <= 1}
                                          >
                                            <img
                                              src={global.OnKeyPressEvent.getS3ImageUrl("minus-icon.svg")}
                                              alt="Vehicle Count"
                                              title="Vehicle Count"
                                            />
                                          </button>
                                        </span>
                                        <span>{this.state.no_of_vehicle}</span>
                                        <span>
                                          <button
                                            type="button"
                                            onClick={this.incrementVehicle}
                                            disabled={this.state.no_of_vehicle >= this.state.maxVehicle}
                                          >
                                            <img
                                              src={global.OnKeyPressEvent.getS3ImageUrl("add-icon.svg")}
                                              alt="Vehicle Count"
                                              title="Vehicle Count"
                                            />
                                          </button>
                                        </span>
                                      </div>
                                    </li>
                                    {this.isParkingApplicable() && (
                                    <li className="parking_total_price">
                                      <span>Total (USD)</span>
                                      <span>${parkingTotal.toFixed(2)}</span>
                                    </li>
                                    )}
                                  </ul>
                                </div>
                              )}
                            </div>

                            {/* Grand Total */}
                            {grandTotal > 0 && (
                              <div className="addons_grand_total">
                                <ul className="parking_pay_detail">
                                  <li className="parking_total_price">
                                    <span>Grand total (USD)</span>
                                    <span>${grandTotal.toFixed(2)}</span>
                                  </li>
                                </ul>
                              </div>
                            )}

                            {this.state.addOnsError && (
                              <p className="text-danger mt-2">{this.state.addOnsError}</p>
                            )}
                          </div>
                        </div>
                      )}

                      {this.state.addOnsSubstate === "vehicle-details" && (
                        <div className="col-sm-12 col-lg-12 bg_wzrd_heading">
                          <div className="wzrd_heading_box col-12 mb-0">
                            <div className="col-xs-12 col-sm-12 col-md-12 mg-b-0">
                              <p className="addons_subtitle mt-3 mb-3">Please enter the details for each vehicle.</p>
                              {this.state.vehicleDetails.map((vehicle, index) => (
                                <div key={index}>
                                  {index > 0 && <hr className="my-3" />}
                                  <h6 className="mb-3">Vehicle {index + 1}</h6>
                                  <div className="row">
                                    <div className="col-12 col-md-3">
                                      <div className="car_color_type">
                                        <span className="pd-t-20 pd-b-0 labelTitle position-relative">Make</span>
                                        <div className="form-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={vehicle.vehicle_make}
                                            onChange={(e) => this.onVehicleDetailChange(index, "vehicle_make", e.target.value)}
                                            placeholder="e.g. Toyota"
                                            autoComplete="off"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-12 col-md-3">
                                      <div className="car_color_type">
                                        <span className="pd-t-20 pd-b-0 labelTitle position-relative">Model</span>
                                        <div className="form-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={vehicle.vehicle_model}
                                            onChange={(e) => this.onVehicleDetailChange(index, "vehicle_model", e.target.value)}
                                            placeholder="e.g. Camry"
                                            autoComplete="off"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-12 col-md-3">
                                      <div className="car_color_type">
                                        <span className="pd-t-20 pd-b-0 labelTitle position-relative">Color</span>
                                        <div className="form-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={vehicle.vehicle_color}
                                            onChange={(e) => this.onVehicleDetailChange(index, "vehicle_color", e.target.value)}
                                            placeholder="e.g. Silver"
                                            autoComplete="off"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-12 col-md-3">
                                      <div className="car_color_type">
                                        <span className="pd-t-20 pd-b-0 labelTitle position-relative">License Plate</span>
                                        <div className="form-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={vehicle.license_plate_number}
                                            onChange={(e) => this.onVehicleDetailChange(index, "license_plate_number", e.target.value)}
                                            placeholder="e.g. ABC-1234"
                                            autoComplete="off"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                              {this.state.addOnsError && (
                                <p className="text-danger mt-2">{this.state.addOnsError}</p>
                              )}
                              <div className="step_btns">
                                <button
                                  type="button"
                                  className="w-100 btn_pre_wzd"
                                  onClick={this.onAddOnsBack}
                                >
                                  Previous
                                </button>
                                <button
                                  type="button"
                                  className="w-100 btn_next_wzd"
                                  disabled={this.state.addOnsLoader}
                                  onClick={this.onVehicleDetailsContinue}
                                >
                                  {this.state.addOnsLoader ? (
                                    <SpinnerLoader />
                                  ) : parseFloat(this.state.currentData?.parking_fee_stripe || 0) === 0 && !this.state.petCleaningEnabled ? (
                                    "Save & Continue"
                                  ) : (
                                    "Proceed to Payment"
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Combined Trip Add-ons payment sub-view */}
                      {this.state.addOnsSubstate === "payment" && this.state.addOnsClientSecret && (
                        <div className="col-sm-12 col-lg-12 bg_wzrd_heading">
                          <div className="wzrd_heading_box col-12 mb-0">
                            <div className="col-xs-12 col-sm-12 col-md-12 mg-b-0 strip_parking">
                              <Elements stripe={stripePromise} options={addOnsOptions}>
                                <InjectedTripAddonsPaymentForm
                                  stripeId={this.state.addOnsStripeId}
                                  confirmation_code={this.state.currentData?.confirmation_code}
                                  items={this.state.addOnsItems}
                                  calculatedAmounts={this.state.addOnsCalculatedAmounts}
                                  vehicleDetails={this.state.vehicleDetails}
                                  onPaymentSuccess={this.onAddOnsPaymentSuccess}
                                  onPrevious={this.onAddOnsBack}
                                />
                              </Elements>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
    const step6Content = (
      <>
        <div className="container-fluid p-0">
          <section className="wzrd_main_section">
            <div className="container">
              <div className="content">
                <div className="row mobView wizard_new_heading">
                  <div className="wzrd_middle_desk mb-0">
                    <div className="col-sm-12 col-lg-12 bg_wzrd_heading mob_sticky_top">
                      <div className="wzrd_heading_box col-12 m-0 ">
                        <h4>
                          {this.state.currentData?.card_screen_tokenise_titles
                            ? this.state.currentData
                                ?.card_screen_tokenise_titles
                            : "Credit card for incidentals"}
                        </h4>
                      </div>
                    </div>

                    <div className="col-sm-12 col-lg-12 bg_wzrd_heading ">
                      <div className="wzrd_heading_box col-12 mb-0">
                        <div className="col-xs-12 col-sm-12 col-md-12 p-0 mg-b-0 check_wizard upload_info_detail credit_card_inst">
                          <FormGroup className="mg-b-15">
                            <FormControl>
                              <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                onChange={(e) => this.changeHandlerDeposite(e)}
                                value={
                                  this.state.card_agree_type
                                    ? this.state.card_agree_type
                                    : 2
                                }
                              >
                                <FormControlLabel
                                  value={2}
                                  control={<Radio />}
                                  label={daysamount}
                                />
                                <FormControlLabel
                                  value={1}
                                  control={<Radio />}
                                  label={depositeTitle}
                                />
                              </RadioGroup>
                              <p className="error-message">
                                {this.state.card_agree_type === ""
                                  ? "Please Select at least one option to continue"
                                  : ""}
                              </p>
                            </FormControl>
                          </FormGroup>
                          {/* <li> Smoking is not allowed in the unit and/or the building.</li> */}
                          {this.state.card_agree_type == 1 ? (
                            <p
                              dangerouslySetInnerHTML={{
                                __html: this.state.currentData
                                  ? this.state.currentData.property
                                      .credit_card_instructions
                                  : "",
                              }}
                            ></p>
                          ) : (
                            <p
                              dangerouslySetInnerHTML={{
                                __html: this.state.currentData
                                  ? this.state.currentData.waivermessage
                                  : "",
                              }}
                            ></p>
                          )}

                          {!this.state.clientToken ? (
                            <div>{/* <h3>Loading...</h3> */}</div>
                          ) : (
                            <Elements stripe={stripePromise} options={options}>
                              <CardForm
                                confirmation_code={
                                  this.state.currentData?.confirmation_code
                                }
                                signature={this.state.signature}
                                pagestate={this.state.pagestate}
                                setPrevious={this.setPrevious.bind(this)}
                                clientSecret={this.state.clientToken}
                                stripe_id={this.state.stripe_id}
                                card_agree_type={this.state.card_agree_type}
                                customer_id={this.state.customer_id}
                                is_form_submited={this.state.is_form_submited}
                                guest_slug={this.state.guest_slug}
                              />
                            </Elements>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );

    return (
      <main className="oh-template Brandmainpage wizard_header wzard_main_bg ">
        <CommonHeader propertySlug={this.state.property_slug} />
        <section className="wizard_sec">
          <div className="row- wizard_row m-0 mobView">
            <div className="wizard_box ">
              <div className="wizard-data req_book_secw-zaed">
                {this.state.pagestate === 1 ? step1Content : ""}
                {this.state.pagestate === 2 ? step2Content : ""}
                {this.state.pagestate === 3 ? step3Content : ""}
                {this.state.pagestate === 4 ? step4Content : ""}
                {this.state.pagestate === 5 ? step5Content : ""}
                {this.state.pagestate === 6 ? step6Content : ""}
              </div>

              <p className="error-message">
                {this.state.imgError ? this.state.imgError : ""}
              </p>
              <div
                className={
                  this.state.pagestate === 6 || (this.state.pagestate === 5 && this.state.addOnsSubstate !== "summary") ? "step_btns d-none" : "step_btns"
                }
              >
                {this.state.pagestate !== 1 && this.state.pagestate !== 6 ? (
                  <button
                    id="book-tour-page"
                    className="w-100 btn_pre_wzd"
                    onClick={this.setPrevious}
                  >
                    Previous
                  </button>
                ) : (
                  ""
                )}
                {!this.state.clientToken && this.state.pagestate === 6 ? (
                  <button
                    id="book-tour-page"
                    className="w-100 btn_pre_wzd"
                    onClick={this.setPrevious}
                  >
                    Previous
                  </button>
                ) : (
                  ""
                )}
                {!this.state.clientToken && this.state.pagestate === 6 ? (
                  <button
                    id="book-tour-page"
                    className="w-100 btn_next_wzd"
                    disabled={this.state.loader ? true : false}
                    onClick={(e) => this.setNext(e)}
                  >
                    Next
                  </button>
                ) : (
                  ""
                )}
                {this.state.pagestate !== 4 && this.state.pagestate !== 5 && this.state.pagestate !== 6 ? (
                  <button
                    id="book-tour-page"
                    className="w-100 btn_next_wzd"
                    disabled={
                      this.state.is_email_verified === 0
                        ? this.state.loader
                          ? true
                          : false
                        : this.state.clickAgain && this.state.pagestate === 1
                        ? true
                        : false
                    }
                    onClick={(e) => this.setNext(e)}
                  >
                    Next
                  </button>
                ) : (
                  ""
                )}

                {this.state.pagestate === 4 ? (
                  <button
                    id="book-tour-page"
                    className="w-100 btn_next_wzd"
                    disabled={this.state.submitloader ? true : false}
                    onClick={(e) => this.onSubmit(e)}
                  >
                    Next
                    {this.state.submitloader ? (
                      <>
                        {" "}
                        <div className="mob_fullscreen">
                          <SpinnerLoader />
                        </div>{" "}
                      </>
                    ) : (
                      ""
                    )}
                  </button>
                ) : (
                  ""
                )}
                {this.state.pagestate === 5 && this.state.addOnsSubstate === "summary" && (
                  <button
                    id="book-tour-page"
                    className="w-100 btn_next_wzd"
                    disabled={this.state.addOnsLoader}
                    onClick={this.onAddOnsContinue}
                  >
                    {this.state.addOnsLoader ? (
                      <SpinnerLoader />
                    ) : grandTotal > 0 ? (
                      "Pay $" + grandTotal.toFixed(2) + " & Continue"
                    ) : (
                      "Continue"
                    )}
                  </button>
                )}

              </div>
            </div>
          </div>
        </section>
        <Modal show={this.state.verifyOtpModal} centered className="otpModal">
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose float-end"
              onClick={() => this.manageVerifyModal(false)}
            >
              {global.closee}
            </span>
            <div>
              <figure className="mg-auto m-auto text-center">
                {this.state.isVerify ? (
                  <>
                    <h2 className="text-success">Code Verified Successfully</h2>
                    <div className="d-flex  mg-t-30 reservationBook bg-white">
                      <a className="text-decoration-none w-100">
                        <button id="book-tour-page" className="w-100">
                          continue{" "}
                          {this.state.submitloader ? (
                            <>
                              <Spinner
                                as="span"
                                animation="grow"
                                role="status"
                                aria-hidden="true"
                              />
                              <Spinner
                                as="span"
                                animation="grow"
                                role="status"
                                aria-hidden="true"
                              />
                              <Spinner
                                as="span"
                                animation="grow"
                                role="status"
                                aria-hidden="true"
                              />
                            </>
                          ) : (
                            ""
                          )}
                        </button>
                      </a>
                    </div>
                  </>
                ) : (
                  <>
                    <h4 className="text-center">
                      <b>Please enter code to continue</b>
                    </h4>
                    <h6 className="mg-b-30">
                      <b>Code sent to :</b> {this.state.display_email}
                    </h6>
                    <TextField
                      type="number"
                      id="OTP"
                      label="Enter Code"
                      variant="outlined"
                      fullWidth
                      name="verify_otp"
                      onChange={this.changeHandler}
                      required
                      error={this.state.verify_otp_error ? true : false}
                      value={this.state.verify_otp}
                    />
                    {this.state.verify_otp_error && (
                      <>
                        <p className="text-danger">
                          {" "}
                          {this.state.verify_otp_error}
                        </p>
                      </>
                    )}
                    <div className="d-flex  mg-t-30 reservationBook bg-white">
                      <button
                        className="w-100"
                        onClick={() => this.verifyOtp()}
                      >
                        Verify{" "}
                        {this.state.loader ? (
                          <>
                            <Spinner
                              as="span"
                              animation="grow"
                              role="status"
                              aria-hidden="true"
                            />
                            <Spinner
                              as="span"
                              animation="grow"
                              role="status"
                              aria-hidden="true"
                            />
                            <Spinner
                              as="span"
                              animation="grow"
                              role="status"
                              aria-hidden="true"
                            />
                          </>
                        ) : (
                          ""
                        )}
                      </button>
                    </div>
                    <Timer
                      minutes={global.countdown_time} // env data ( Pass the no of minutes:seconds that you want count )
                      resendEvent={this.resendOtp.bind(this)} //  Resend button event you can pass your function name here
                    />
                  </>
                )}
              </figure>
            </div>
          </Modal.Body>
        </Modal>
      </main>
    );
  }
}
export default WizardForm;
